import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const orderConfirmation = Loadable(() => import('../../containers/web/index'));
export default MapTo('vcg/components/soe-home/react/orderConfirmation')(orderConfirmation);
